import { atarrayaApi } from '../../api-common'

export const state = {
  tasks: [],
  taskCatalog: [],
  taskContainers: [],
  taskContainersActive: [],
  taskContainersActiveByDate: [],
  waterQuality: [],
  waterLevel: [],
  weeklyReport: [],
  weeklyTasks: [],
  acumulatedBiomass: [],
  manualTask: [],
  populationsByFarms: [],
  wasteLevel: [],
  zooReport: [],
  feedingReport: [],
  biomassReport: [],
  biometriReport: [],
  taskModules: [],
  pupulationsActive: [],
  biomasHarvested: [],
  vibriosReport: [],
  timeOfTask: [],
  harvestReport: [],
  transferReport: [],
  taskTimeReport: [],
  additivesReport: [],
  populationByContainer: [],
  sowingData: [],
  projections: [],
  harvest: [],
  harvestProjections: [],
  currentHarvest: [],
  lastBiomass: [],
}

export const getters = {
  tasks: (state) => state.tasks,
  taskCatalog: (state) => state.taskCatalog,
  taskContainers: (state) => state.taskContainers,
  taskContainersActive: (state) => state.taskContainersActive,
  taskContainersActiveByDate: (state) => state.taskContainersActiveByDate,
  waterQuality: (state) => state.waterQuality,
  waterLevel: (state) => state.waterLevel,
  wasteLevel: (state) => state.wasteLevel,
  weeklyReport: (state) => state.weeklyReport,
  weeklyTasks: (state) => state.weeklyTasks,
  acumulatedBiomass: (state) => state.acumulatedBiomass,
  manualTask: (state) => state.manualTask,
  //populationsByFarms: (state) => state.populationsByFarms,
  populationsByFarms: (state) => {
    // Combina datos locales con el estado del store
    return state.populationsByFarms.map(pop => {
      const localPop = state.populationList.find(lp => lp.id === pop.id);
      return localPop ? {...pop, ...localPop} : pop;
    });
  },
  zooReport: (state) => state.zooReport,
  feedingReport: (state) => state.feedingReport,
  biomassReport: (state) => state.biomassReport,
  biometriReport: (state) => state.biometriReport,
  taskModules: (state) => state.taskModules,
  pupulationsActive: (state) => state.pupulationsActive,
  biomasHarvested: (state) => state.biomasHarvested,
  vibriosReport: (state) => state.vibriosReport,
  timeOfTask: (state) => state.timeOfTask,
  harvestReport: (state) => state.harvestReport,
  transferReport: (state) => state.transferReport,
  taskTimeReport: (state) => state.taskTimeReport,
  additivesReport: (state) => state.additivesReport,
  populationByContainer: (state) => state.populationByContainer,
  sowingData: (state) => state.sowingData,
  projections: (state) => state.projections,
  harvest: (state) => state.harvest,
  harvestProjections: (state) => state.harvestProjections,
  currentHarvest: (state) => state.currentHarvest,
  lastBiomass: (state) => state.lastBiomass,
}

export const mutations = {
  LOAD_TASKS(state, data) {
    state.tasks = data
  },

  LOAD_LAST_BIOMASS(state, data) {
    state.lastBiomass = data
  },

  ADD_TASK(state, data) {
    state.tasks.push(data)
  },

  CANCEL_TASK(state, item) {
    state.tasks.splice(state.tasks.indexOf(item), 1)
  },

  CANCEL_MANY_TASK(state, item) {
    state.tasks.splice(state.tasks.indexOf(item), 1)
  },

  LOAD_TASK_CATALOG(state, data) {
    state.taskCatalog = data
  },

  ADD_TASK_CATALOG(state, data) {
    state.taskCatalog.push(data)
  },

  LOAD_TASKS_CONTAINERS(state, data) {
    state.taskContainers = data
  },

  LOAD_TASKS_CONTAINERS_ACTIVE(state, data) {
    state.taskContainersActive = data
  },

  LOAD_TASKS_CONTAINERS_ACTIVE_BY_DATE(state, data) {
    state.taskContainersActiveByDate = data
  },

  CHANGE_CONTAINER_AVAILABILITY(state, item) {
    state.taskContainers.splice(state.taskContainers.indexOf(item), 1)
  },

  LOAD_WATER_QUALITY(state, data) {
    state.waterQuality = data
  },

  LOAD_WATER_LEVEL(state, data) {
    state.waterLevel = data
  },

  LOAD_WASTE_LEVEL(state, data) {
    state.wasteLevel = data
  },

  LOAD_WEEKLY_REPORT(state, data) {
    state.weeklyReport = data
  },

  LOAD_WEEKLY_TASKS(state, data) {
    state.weeklyTasks = data
  },

  CANCEL_MAIN_TASKS(state, data) {
    data.tasks.forEach((element) => {
      state.weeklyTasks.splice(
        state.weeklyTasks.findIndex((obj) => obj.id === element),
        1
      )
    })
  },

  UPDATE_MEASURE_TASK(state, item) {
    state.tasks.splice(state.tasks.indexOf(item), 1)
  },

  DELETE_MEASURE_TASK(state, item) {
    state.tasks.splice(state.tasks.indexOf(item), 1)
  },

  LOAD_ACOMULATE_BIOMASS(state, data) {
    state.acumulatedBiomass = data
  },

  ADD_BIOMASS_AJUSTED_TASK(state, data) {
    state.manualTask.push(data)
  },

  LOAD_POPULATIONS_BY_FARMS(state, data) {
    state.populationsByFarms = data
  },

  LOAD_ZOO_REPORT(state, data) {
    state.zooReport = data
  },

  LOAD_FEEDING_REPORT(state, data) {
    state.feedingReport = data
  },

  LOAD_BIOMASS_REPORT(state, data) {
    state.biomassReport = data
  },

  LOAD_BIOMITRIC_REPORT(state, data) {
    state.biometriReport = data
  },

  LOAD_TASKS_MODULE_ACTIVE(state, data) {
    state.taskModules = data
  },

  LOAD_POPULATION_ACTIVE(state, data) {
    state.pupulationsActive = data
  },

  LOAD_BIOMASS_HARVERTED_REPORT(state, data) {
    state.biomasHarvested = data
  },

  ASSIGN_TASKS(state, data) {
    state.taskContainers = data
  },

  LOAD_VIBRIOS_REPORT(state, data) {
    state.vibriosReport = data
  },

  LOAD_TIME_OF_TASKS(state, data) {
    state.timeOfTask = data
  },

  ADD_TIME_OF_TASK(state, data) {
    state.timeOfTask.push(data)
  },

  LOAD_HARVEST_REPORT(state, data) {
    state.harvestReport = data
  },

  LOAD_TRANSFER_REPORT(state, data) {
    state.harvestReport = data
  },

  LOAD_TIME_TASK_REPORT(state, data) {
    state.taskTimeReport = data
  },

  LOAD_ADDITIVES_REPORT(state, data) {
    state.additivesReport = data
  },

  LOAD_PUPOLATION_BY_CNT(state, data) {
    state.populationByContainer = data
  },

  LOAD_SOWING(state, data) {
    state.sowingData = data
  },

  LOAD_PROJECTION(state, data) {
    state.projections = data;
  },

  ADD_HARVEST(state, data) {
    state.harvest.push(data)
  },

  LOAD_HARVEST_PROJECTION(state, data) {
    state.harvestProjections = data;
  },

  LOAD_CURRENT_HARVEST(state, data) {
    state.currentHarvest = data;
  },

  UPDATE_POPULATION_SETTINGS (state, data) {
    const index = state.populationsByFarms.findIndex(p => p.id === data.id);
    if (index !== -1) {
      state.populationsByFarms[index] = {
        ...state.populationsByFarms[index],
        ...data.settings
      };
    }
  }
}

export const actions = {
  async getTasks({ commit }, data) {
    const response = await atarrayaApi.get(
      '/engine/tasks/scheduled/dashboard',
      {
        params: {
          date: data.date,
          farm: data.farmId,
          containers: data.containers
        }
      }
    )
    commit('LOAD_TASKS', response.data.data)
    return response.data.data
  },

  async addTask({ commit }, data) {
    const response = await atarrayaApi.post('/engine/tasks/scheduling', data)
    commit('ADD_TASK', response.data.data)
  },

  async addFeedingTask({ commit }, data) {
    const response = await atarrayaApi.post('/engine/tasks/feeding', data)
    commit('ADD_TASK', response.data.data)
  },

  async cancelTask({ commit }, data) {
    const response = await atarrayaApi.post(
      `/engine/tasks/${data.taskId}/cancel`,
      data
    )
    commit('CANCEL_TASK', response.data.data)
  },

  async cancelManyTaska({ commit }, data) {
    const response = await atarrayaApi.post('/engine/tasks/cancel/many', data)
    commit('CANCEL_MANY_TASK', response.data.data)
  },

  async getTaskCatalog({ commit }, data) {
    const response = await atarrayaApi.get('/engine/tasks/catalog', {
      params: { farmId: data }
    })
    commit('LOAD_TASK_CATALOG', response.data.data)
    return response.data.data
  },

  async addTaskCatalog({ commit }, data) {
    const response = await atarrayaApi.post('/engine/tasks/catalog', data)
    commit('ADD_TASK_CATALOG', response.data.data)
  },

  async getTasksContainers({ commit }, data) {
    const response = await atarrayaApi.get(
      `/engine/farms/containers?farm=${data}&with=clarifier&with=skimmer`
    )
    commit('LOAD_TASKS_CONTAINERS', response.data.data)
    return response.data.data
  },

  async getTasksContainersActive({ commit }, data) {
    const response = await atarrayaApi.get('/engine/farms/containers', {
      params: { farm: data, availability: true }
    })
    commit('LOAD_TASKS_CONTAINERS_ACTIVE', response.data.data)
    return response.data.data
  },

  async getTasksContainersActiveByDate({ commit }, data) {
    const availability = data.availability ? true : null
    const response = await atarrayaApi.get('/engine/farms/containers', {
      params: { farm: data.farmId, availability: availability }
    })

    commit('LOAD_TASKS_CONTAINERS_ACTIVE_BY_DATE', response.data.data)
    return response.data.data
  },

  async filterByExpiration(items, date) {
    items.filter(function () {
      return items.disabledAt > date
    })
  },

  async changeContainerAvailability({ commit }, data) {
    const response = await atarrayaApi.patch('/engine/farms/containers/task-availability', data)
    commit('CHANGE_CONTAINER_AVAILABILITY', response.data.data)
  },

  async getSampling({ commit }, data) {
    let type = ''
    if (data.type == 'water-quality-lab') type = 'water-quality'
    else type = data.type
    const response = await atarrayaApi.get(`/engine/sampling/${type}`, {
      params: {
        tz: data.tz,
        pplId: data.pplId,
        cntId: data.cntId,
        from: data.from,
        to: data.to,
        src: data.src
      }
    })
    commit('LOAD_WATER_QUALITY', response.data.data)
    return response.data.data
  },

  async getWeeklyReport({ commit }, data) {
    const response = await atarrayaApi.get('/engine/dashboards/kpis', {
      params: {
        farm: data.farmId,
        date: data.date,
        size: data.size,
        mortality: data.mortality,
        expectedGrowth: data.expectedGrowth
      }
    })
    commit('LOAD_WEEKLY_REPORT', response.data.data)
    return response.data.data
  },

  async getWeeklyTasks({ commit }, data) {
    const response = await atarrayaApi.get('/engine/tasks', {
      params: {
        farm: data.farmId,
        startingAt: data.startingAt,
        endingAt: data.endingAt
      }
    })
    commit('LOAD_WEEKLY_TASKS', response.data.data)
    return response.data.data
  },

  async cancelMainTasks({ commit }, data) {
    await atarrayaApi.delete('/engine/tasks', { data: data })
    commit('CANCEL_MAIN_TASKS', data)
  },

  async changeMeasureValue({ commit }, data) {
    let type = ''
    if (data.type == 'water-quality-lab' || data.type == 'vibrios')
      type = 'water-quality'
    else type = data.type
    const response = await atarrayaApi.patch(
      `/engine/sampling/${type}?ref=${data.ref}`,
      { entries: data.body }
    )
    commit('UPDATE_MEASURE_TASK', response.data.data)
  },

  async deleteMeasureTask ({ commit }, data) {
    let type = ''
    if (data.type == 'water-quality-lab') type = 'water-quality'
    else type = data.type
    const response = await atarrayaApi.delete(
      `/engine/sampling/${type}?ref=${data.ref}&entry=${data.measure}`
    )
    commit('DELETE_MEASURE_TASK', response.data.data)
  },

  async restartMeasureTask({ commit }, data) {
    let type = ''
    if (data.type == 'water-quality-lab') type = 'water-quality'
    else type = data.type
    const response = await atarrayaApi.delete(
      `/engine/sampling/${type}/all?ref=${data.ref}`
    )
    commit('DELETE_MEASURE_TASK', response.data.data)
  },

  async getAcumulatedBiomass({ commit }, data) {
    const response = await atarrayaApi.get(
      '/engine/dashboards/container/acumulated-biomass',
      {
        params: {
          farm: data.farmId,
          container: data.containers,
          date: data.date,
          mortality: data.mortality
        }
      }
    )
    commit('LOAD_ACOMULATE_BIOMASS', response.data.data)
    return response.data.data
  },

  async addBiomassManualTask({ commit }, data) {
    const response = await atarrayaApi.post('/engine/sampling/biomass/manual', data)
    commit('ADD_BIOMASS_AJUSTED_TASK', response.data.data)
  },

  async getPopulationsByFarm({ commit }, data) {
    const response = await atarrayaApi.get('/engine/farms/populations', {
      params: {
        farm: data.farmId,
        with: data.with,
        status: data.status
      }
    })
    commit('LOAD_POPULATIONS_BY_FARMS', response.data.data)
    return response.data.data
  },

  async loadZooReport({ commit }, data) {
    const response = await atarrayaApi.post(
      '/engine/dashboards/zootechnical-report',
      data
    )
    commit('LOAD_ZOO_REPORT', response.data.data)
    return response.data.data
  },

  async loadFeedReport({ commit }, data) {
    const response = await atarrayaApi.get('/engine/interventions/feeding', {
      params: {
        tz: data.tz,
        from: data.from,
        to: data.to,
        pplId: data.pplId,
        with: 'task'
      }
    })
    commit('LOAD_FEEDING_REPORT', response.data.data)
    return response.data.data
  },

  async loadBiomassReport({ commit }, data) {
    const response = await atarrayaApi.get('/engine/sampling/biomass', {
      params: {
        tz: data.tz,
        from: data.from,
        to: data.to,
        cntId: data.cntId,
        pplId: data.pplId,
        type: data.type
      }
    })
    commit('LOAD_BIOMASS_REPORT', response.data.data)
    return response.data.data
  },

  async loadBiometricReport({ commit }, data) {
    const response = await atarrayaApi.get('/engine/sampling/biometrics', {
      params: {
        tz: data.tz,
        from: data.from,
        to: data.to,
        cntId: data.cntId,
        pplId: data.pplId,
        type: data.type
      }
    })
    commit('LOAD_BIOMITRIC_REPORT', response.data.data)
    return response.data.data
  },

  async getTasksModulesActive({ commit }, data) {
    const response = await atarrayaApi.get('/engine/farms/modules', {
      params: { farm: data, availability: true }
    })
    commit('LOAD_TASKS_MODULE_ACTIVE', response.data.data)
    return response.data.data
  },

  async getPopulationsActive({ commit }, data) {
    const response = await atarrayaApi.get('/engine/farms/populations', {
      params: { farm: data, status: 'started' }
    })
    commit('LOAD_POPULATION_ACTIVE', response.data.data)
    return response.data.data
  },

  async loadBiomassHarvestedReport({ commit }, data) {
    const response = await atarrayaApi.get('/engine/interventions/harvest', {
      params: {
        tz: data.tz,
        from: data.from,
        to: data.to,
        cntId: data.cntId,
        pplId: data.pplId,
        type: data.type
      }
    })
    commit('LOAD_BIOMASS_HARVERTED_REPORT', response.data.data)
    return response.data.data
  },

  async assignTask({ commit }, data) {
    const response = await atarrayaApi.post('/engine/tasks/assign/many', data)
    commit('ASSIGN_TASKS', response.data.data)
  },

  async adjustmentFeedintTask({ commit }, data) {
    const response = await atarrayaApi.patch(
      '/engine/tasks/feeding/adjustment',
      data
    )
    commit('ASSIGN_TASKS', response.data.data)
  },

  async getWaterQualitySampling({ commit }, data) {
    const response = await atarrayaApi.get('/engine/sampling/water-quality', {
      params: {
        tz: data.tz,
        pplId: data.pplId,
        cntId: data.cntId,
        from: data.from,
        to: data.to,
        with: 'task',
        src: data.src
      }
    })
    commit('LOAD_WATER_QUALITY', response.data.data)
    return response.data.data
  },

  async getVibriosSampling({ commit }, data) {
    const entries = [
      'vibrio_ssp',
      'parahaemolyticus',
      'alginolyticus',
      'vulnificus'
    ]
    const response = await atarrayaApi.get('/engine/sampling/water-quality', {
      params: {
        tz: data.tz,
        pplId: data.pplId,
        cntId: data.cntId,
        from: data.from,
        to: data.to,
        src: data.src,
        entry: entries
      }
    })
    commit('LOAD_WATER_QUALITY', response.data.data)
    return response.data.data
  },

  async getTimeOfTasks({ commit }, data) {
    const response = await atarrayaApi.get('/engine/task-execution-time', {
      params: {
        date: data.date,
        farmId: data.farmId
      }
    })
    commit('LOAD_TIME_OF_TASKS', response.data.data)
    return response.data.data
  },

  async addTimeOfTask({ commit }, data) {
    const response = await atarrayaApi.post('/engine/task-execution-time', data)
    commit('ADD_TIME_OF_TASK', response.data.data)
  },

  async loadHarvestReport({ commit }, data) {
    const response = await atarrayaApi.get('/engine/interventions/harvest', {
      params: {
        tz: data.tz,
        from: data.from,
        to: data.to,
        pplId: data.pplId
      }
    })
    commit('LOAD_HARVEST_REPORT', response.data.data)
    return response.data.data
  },

  async loadTransferReport({ commit }, data) {
    const response = await atarrayaApi.get('/engine/interventions/transfers', {
      params: {
        tz: data.tz,
        from: data.from,
        to: data.to,
        pplId: data.pplId
      }
    })
    commit('LOAD_TRANSFER_REPORT', response.data.data)
    return response.data.data
  },

  async loadTaskTimeReport({ commit }, data) {
    const response = await atarrayaApi.get(
      '/engine/task-execution-time/report',
      {
        params: {
          farmId: data.farmId,
          date: data.date,
          status: data.status
        }
      }
    )
    commit('LOAD_TIME_TASK_REPORT', response.data.data)
    return response.data.data
  },

  async loadAdditivesReport({ commit }, data) {
    const response = await atarrayaApi.get('/engine/interventions/additive', {
      params: {
        tz: data.tz,
        from: data.from,
        to: data.to,
        pplId: data.pplId
      }
    })
    commit('LOAD_ADDITIVES_REPORT', response.data.data)
    return response.data.data
  },

  async getPopulationByCnt ({ commit }, data) {
    const response = await atarrayaApi.get(
      '/engine/farms/populations',
      {
        params: {
          farm: data.farmId,
          cnt: data.cntId,
          id: data.popId,
          status: ['started', 'scheduled']
        }
      }
    )
    commit('LOAD_PUPOLATION_BY_CNT', response.data.data)
    return response.data.data
  },

  async getSowingByPopulationId ({ commit }, item) {
    const response = await atarrayaApi.get(
      '/engine/interventions/sowing',
      {
        params: {
          pplId: item
        }
      }
    )
    commit('LOAD_SOWING', response.data.data)
    return response.data.data
  },

  async getSowings ({ commit }, data) {
    const response = await atarrayaApi.get(
      '/engine/interventions/sowing',
      {
        params: {
          pplId: data.pplId
        }
      }
    )
    commit('LOAD_SOWING', response.data.data)
    return response.data.data
  },

  async getIonicBalance({ commit }, data) {
    const response = await atarrayaApi.get(`/engine/sampling/water-quality`, {
      params: {
        tz: data.tz,
        entry: data.entry,
        pplId: data.pplId,
        cntId: data.cntId,
        from: data.from,
        to: data.to,
        src: data.src
      }
    })
    commit('LOAD_WATER_QUALITY', response.data.data)
    return response.data.data
  },

  async getProjection ({ commit }, data) {
    const response = await atarrayaApi.post('/engine/dashboards/zootechnical-projections', data.fullData ,{
      params: {
        growth: data.growth,
        nurserygrowth: data.nurserygrowth,
        estimatedSurvivalRate: data.estimatedSurvivalRate,
        weeks: data.weeks,
        maxDensity: data.maxDensity,
        containerize: data.containerize,
        harvestDensity: data.harvestDensity
      }
    });

    commit('LOAD_PROJECTION', response.data);
    return response.data.data;
  },

  async extendProjection ({ commit }, data) {
    const response = await atarrayaApi.post('/engine/dashboards/extend-projections', data.fullData ,{
      params: {
        growth: data.growth,
        estimatedSurvivalRate: data.estimatedSurvivalRate,
        weeks: data.weeks,
        maxDensity: data.maxDensity,
        containerize: data.containerize,
        harvestDensity: data.harvestDensity
      }
    });

    commit('LOAD_PROJECTION', response.data);
    return response.data.data;
  },

  async addHarvest ({ commit }, data) {
    const response = await atarrayaApi.post('/engine/dashboards/add-harvest', data);
    commit('ADD_HARVEST', response.data);
    return response.data;
  },

  async getHarvestProjections ({ commit }, data) {
    const response = await atarrayaApi.get(
      '/engine/dashboards/get-harvest',
      {
        params: {
          populationId: data.populationId,
          fromDate: data.fromDate
        }
      }
    )
    commit('LOAD_HARVEST_PROJECTION', response.data.data)
    return response.data.data
  },

  async getCurrentHarvest ({ commit }, data) {
    const response = await atarrayaApi.get(
      '/engine/dashboards/get-harvest-farm',
      {
        params: {
          farmId: data.farmId,
          fromDate: data.fromDate
        }
      }
    )
    commit('LOAD_CURRENT_HARVEST', response.data.data)
    return response.data.data
  },

  async getLastBiomass({ commit }, data) {
    const response = await atarrayaApi.get(
      '/engine/sampling/biomass/latest',
      {
        params: {
          from: data.from,
          to: data.to,
          cntId: data.cntId
        }
      }
    )
    commit('LOAD_LAST_BIOMASS', response.data.data)
    return response.data.data
  },

  async updatePopulationSettings ({ commit }, data) {
    const { populationId, settings } = data;
    const response = await atarrayaApi.patch(
      `/engine/farms/populations/${populationId}`,
      settings
    );
    commit('UPDATE_POPULATION_SETTINGS', {
      id: populationId,
      settings: response.data.data
    });
    return response.data.data;
  },
}
